import axios from 'axios'
import { MessageBox, Message } from 'element-ui'
import store from '@/store'
import { getToken } from '@/utils/auth'

// https://github.com/axios/axios
// create an axios instance
const service = axios.create({
  // baseURL: 'http://www.travelwink.cn',
  baseURL: process.env.VUE_APP_BASE_API, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout
  timeout: 50000 // request timeout
})

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent

    if (store.getters.token) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      // config.headers['X-Token'] = getToken()
      config.headers['token'] = getToken()
      config.headers['language'] = store.getters.language
    }
    return config
  },
  error => {
    // do something with request error
    console.log(error) // for debug
    return Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    // debugger
    const res = response.data
    const code = res.code
    const resultData = response.data.data;
    

    // if the custom code is not 20000, it is judged as an error.
    if (code !== 200) {
      // 5001: 请求参数校验异常
      if (code === 5001 || code === 5000 || code === 5002 || code === 5003 || code === 5004 || code === 5005 || code === 5006) {
        let errorMessage = ''
        if (resultData) {
          if (resultData instanceof Array) {
            const length = resultData.length
            resultData.forEach((item, index) => {
              console.log(index + '-' + item)
              errorMessage += item
              if (index !== (length - 1)) {
                errorMessage += "<br/><br/>"
              }
            })
          } else {
            errorMessage += resultData
          }
        } else {
          errorMessage = '请求参数校验异常'
        }
        Message({
          message: errorMessage || 'Error',
          type: 'error',
          showClose: true,
          dangerouslyUseHTMLString: true,
          duration: 2 * 1000
        })
      } else if (code === 206 || code === 5101) {
        Message({
          message: res.message,
          type: 'warning',
          showClose: true,
          duration: 2 * 1000
        })
      } else if (code === 5109) {
        MessageBox.confirm('Account information has expired, please log in again', {
          confirmButtonText: 'Exit',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          window.location.href = process.env.VUE_APP_USERCENTER_URL
        }).catch(() => {
          window.location.href = 'about:blank'
          window.close()
        })
      } else if (code === 5104 || code === 5101 || code === 5102 || code === 5103 || code === 5105 || code === 5106 || code === 5107 || code === 5108 || code === 5100 || code === 4000 || code === 500 || code === 403 || code === 404) {
        Message({
          message: res.message,
          type: 'error',
          showClose: true,
          duration: 2 * 1000
        })
      } else if (code === 401) {
        const roles = localStorage.getItem(roles);
        if (roles === 'visitor') {
          window.location.href = process.env.VUE_APP_BASE_URL + '/#/login'
          return
        }
        if (roles === "overseas") {
          window.location.href = "/overseas";
          return
        }
        // debugger
        // if (res.name === 'visitor') {
        //   store.dispatch('user/visitor').then(() => {
        //     location.reload()
        //     window.location.href = "/visitor?redirect=/visitor";
        //   })
        //   return
        // }
        store.dispatch('user/resetToken').then(() => {
          debugger
          // window.location.href = "/login?redirect=/";
          // window.location.href = "https://ssotest.wm-motor.com/login";
        })
        return;
      } else if (code === 50008 || code === 50012 || code === 50014) {
        // to re-login
        MessageBox.confirm('You have been logged out, you can cancel to stay on this page, or log in again', 'Confirm logout', {
          confirmButtonText: 'Re-Login',
          cancelButtonText: 'Cancel',
          type: 'warning'
        }).then(() => {
          store.dispatch('user/resetToken').then(() => {
            location.reload()
          })
        })
      } 
      // else {
      //   Message({
      //     message: res.message || 'Error',
      //     type: 'error',
      //     showClose: true,
      //     duration: 2 * 1000
      //   })
      // }
      // Promise.reject(new Error(res.message || 'Error'))
      // 当状态码不是200时，是否需要返回响应结果给调用方
      return res
    } else {
      return res
    }
  },
  error => {
    // debugger
    const r = localStorage.getItem("roles");
    // roles[0] === "visitor" console.log(roles, roles[0], roles[0] === "visitor")
    console.log('err', error, "roles", r) // for debug
    // token expire

    if (error.response.data.code === 401) {
      store.dispatch('user/resetToken').then(() => {
        // location.reload()
        MessageBox.confirm('您已登出', '请重新登录', {
          confirmButtonText: '登录',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          window.location.href = process.env.VUE_APP_BASE_URL + '/#/login';
        }).catch(() => {
          window.location.href = "about:blank";
          window.close();
        })
      })
      return;
    }
    return Promise.reject(error)
  }
)

export default service
